import axios from 'axios'

const httpClient = axios.create({
  baseURL: process.env.VUE_APP_IS_PUBLIC ? '/public-site/' : '/app/',
  headers: {
    'Content-Type': 'application/json',
    'X-Requested-With': 'XMLHttpRequest'
  }
})

// interceptor to catch errors
const errorInterceptor = error => {
  return Promise.reject(error)
}

// Interceptor for responses
const responseInterceptor = response => response

httpClient.interceptors.response.use(responseInterceptor, errorInterceptor)

export default httpClient
